import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {colors} from 'shells/colors/colors';
import {WebFormIcon, Pencil} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import type {SaveState} from 'shells/saved-setting-toast/use-manage-save-state';
import {SelectTwoLineIcon} from 'shells/select-two-line-icon/select-two-line-icon';
import {CharacterLimitedTextfield} from 'shells/textfield/character-limited-textfield';
import {Body} from 'shells/typography/body';
import {LabelWithContent} from 'shells/typography/label-with-content';

import type {GetChatSettings_chatSettings_offline_form as Form} from 'nutshell-graphql-types';

import {SAVE_DELAY, SAVE_STATE_KEYS, OFFLINE_MESSAGE_LIMIT} from '../consts';
import type {SaveStateKey} from '../consts';

type Props = {
    message: string;
    setMessage: (message: string) => void;
    form: Form;
    savingToastKey?: SaveStateKey | null | undefined;
    toastState?: SaveState;
};

const getOfflineFormOption = (form: Form) => {
    return {
        value: form.id,
        label: form.name,
        // @ts-expect-error
        iconNode: <WebFormIcon size={19} fill={colors.grey} wrapWithDiv={false} />,
    };
};

export function OfflineEnabledContent(props: Props) {
    const offlineFormOption = getOfflineFormOption(props.form);

    return (
        <>
            <LabelWithContent
                label='Offline message'
                state={
                    props.savingToastKey === SAVE_STATE_KEYS.OFFLINE_MESSAGE
                        ? props.toastState
                        : 'initial'
                }
                spacing={8}
                content={
                    <CharacterLimitedTextfield
                        value={props.message}
                        onChange={props.setMessage}
                        maxLength={OFFLINE_MESSAGE_LIMIT}
                        placeholder='Add your offline message…'
                        isMultiLine={true}
                        isDebouncedSave={true}
                        debouncedSaveDelay={SAVE_DELAY}
                    />
                }
            />
            <LabelWithContent
                label='Offline form'
                labelPopoverProps={{
                    info: 'Configure the form visitors will see when your team is offline',
                    bodyColor: 'dark',
                }}
                spacing={12}
                content={
                    <Stack spacing={12}>
                        <SelectTwoLineIcon
                            options={[offlineFormOption]}
                            placeholder='Select a form'
                            value={offlineFormOption}
                            onChange={() => {}}
                            isDisabled={true}
                        />
                        <div className='flex justify-end'>
                            <Link
                                // @ts-expect-error
                                as={RouterLink}
                                to={props.form.htmlUrlPath}
                                variant='primary'
                                size='small'
                            >
                                {/* @ts-expect-error */}
                                <Stack spacing={8} isHorizontal={true} alignCenter={true}>
                                    <Pencil size={16} />
                                    <Body size='small' color='blue'>
                                        Edit form
                                    </Body>
                                </Stack>
                            </Link>
                        </div>
                    </Stack>
                }
            />
        </>
    );
}
